<script>
	import { fly } from "svelte/transition";
	import { cubicOut } from "svelte/easing";

	import SongRow, { stopAll } from "./components/SongRow.svelte";
	import Switch from "./components/Switch.svelte";
	import MoreLess from "./components/MoreLess.svelte";

	import iconSpeaker from "./images/speaker.svg";
	import { songs } from "./data";

	const LOCAL = true;
	let allow3rdParty = LOCAL;

	let elemMain;
	let showMore = false;

	const limit = 10;
	$: shownSongs = songs.filter((s, i) => showMore || i < limit);
	// $: currentlyPlaying = shownSongs.find((song) => song.isPlaying)?.id;
</script>

<div class="songs" bind:this={elemMain}>
	{#if !LOCAL}
		<div class="third-party">
			<Switch bind:value={allow3rdParty} design="slider" label="Externen Inhalt einblenden" />
			<div>Beim Anzeigen externen Inhalte werden Daten an Dritte übertragen</div>
		</div>
	{/if}

	<table>
		<thead>
			<tr>
				<th class="above-textwidth-only">Rank</th>
				<th>Cover</th>
				<th>Song</th>
				<th class="preview"><img src={iconSpeaker} alt="" /><span>abspielen</span></th>
				<th class="links">Links</th>
			</tr>
		</thead>
		<tbody>
			{#each shownSongs as s, i}
				<tr
					class="row"
					in:fly={{ easing: cubicOut, y: -50, opacity: 0, delay: (i - limit) * 50 }}
					out:fly={{ easing: cubicOut, y: -50, opacity: 0, delay: (shownSongs.length - 1 - i) * 50 }}
				>
					<SongRow
						id={s.id}
						cover={LOCAL ? s.cover_local : s.cover_url}
						snippet={LOCAL ? s.song_snipped_local : s.song_snipped}
						title={s.title}
						artist={s.artist}
						year={s.year}
						rank={i + 1}
						linkSpotify={s.song_spotify}
						linkYoutube={s.song_youtube}
						bind:isPlaying={s.isPlaying}
						on:play={(e) => stopAll(e.detail.id)}
					/>
				</tr>
			{/each}
		</tbody>
	</table>
	<MoreLess bind:more={showMore} scrollToElement={elemMain} />
</div>

<style lang="scss">
	.songs {
		font-family: $ff-sans;
		color: $songswhite;
		font-size: 13px;
		line-height: 16px;
	}

	.third-party {
		margin-bottom: 30px;
	}

	table {
		width: 100%;

		thead {
			font-size: 12px;
			line-height: 14px;
			letter-spacing: 0.03em;
			color: $songswhite;
			border-radius: 6px;
			text-align: left;

			@media (min-width: $breakpoint-textwidth) {
				font-size: 14px;
				line-height: 25px;
			}

			th {
				font-weight: $medium;
				background: $songsgrey;
				padding-top: 2px;
				padding-bottom: 2px;
				white-space: nowrap;

				$r: 6px;
				&:first-child {
					border-radius: $r 0 0 $r;
					padding-left: 6px;
				}

				&:nth-child(2) {
					@media (max-width: $breakpoint-textwidth) {
						border-radius: $r 0 0 $r;
						padding-left: 6px;
					}
				}

				&:last-child {
					border-radius: 0 $r $r 0;
					padding-right: 6px;
				}

				&.preview {
					display: flex;
					align-items: center;
					padding-right: 5px;

					img {
						margin-right: 3px;
						display: inline-block;
						width: unset;
					}
				}

				&.links {
					padding-left: 5px;
					min-width: 35px;
				}
			}
		}
	}
</style>
